import { zSchema } from "../../../schema-validation";

export const companyDebitTransactionsSchema = zSchema.object({
  start_date: zSchema.string().optional(),
  end_date: zSchema.string().optional(),
});
